module.exports = __webpack_public_path__ + "static/media/09.e4a7be4b.png";